var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBiomarker(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00065 17.3342C10.864 17.3342 13.6673 14.4442 13.6673 10.4625C13.6673 5.26919 7.73565 1.00086 7.48315 0.821688C7.34243 0.72183 7.17417 0.668118 7.00162 0.667969C6.82906 0.66782 6.66072 0.72124 6.51982 0.820855C6.26732 0.998355 0.333984 5.25336 0.333984 10.4592C0.333984 14.4425 3.13732 17.3342 7.00065 17.3342ZM6.99982 2.55086C8.33732 3.62586 12.0007 6.89585 12.0007 10.4625C12.0007 13.5275 9.94398 15.6675 7.00065 15.6675C4.05732 15.6675 2.00065 13.5259 2.00065 10.4592C2.00065 6.88419 5.66232 3.62336 6.99982 2.55086Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiomarker);
export default __webpack_public_path__ + "static/media/biomarker.e89b812e039fec0de8d64742311bb871.svg";
export { ForwardRef as ReactComponent };